import {Component, Input, ViewChild} from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';


export interface Item {
  value: string;
  viewValue: string;
}


/**
 * @title Basic select
 */
@Component({
  selector: 'select-overview-example',
  template:`
    <h6>Select {{ itemName }}</h6>
    <mat-form-field>
      <mat-label>{{ itemName }}</mat-label>
      <mat-select [(value)]="selected">
        <mat-option *ngFor="let item of items" [value]="item.viewValue">
          {{item.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styleUrls: [],
})

export class DropdownComponent {
  @Input() itemName: string;
  @Input() itemIndex: number;
  @Input() itemList : string[];
  items: Item[] = [];
  selected = ' ';

  ngOnInit() {
    this.setItems();
  }

  setItems() {
    if (this.itemIndex == 0) {
      this.items = [
        {value: 'breakfast-0', viewValue: 'Breakfast'},
        {value: 'lunch-1', viewValue: 'Lunch'},
        {value: 'dinner-2', viewValue: 'Dinner'},
        {value: 'snack-3', viewValue: 'Snack'},
        {value: 'drink-4', viewValue: 'Drink'}
      ]
    } else if (this.itemIndex == 1) {
      this.items = [
        {value: 'portion-0', viewValue: '1'},
        {value: 'portion-1', viewValue: '2'},
        {value: 'portion-2', viewValue: '3'},
        {value: 'portion-3', viewValue: '4'},
        {value: 'portion-4', viewValue: '5'},
        {value: 'portion-5', viewValue: '6'},
        {value: 'portion-6', viewValue: '7'},
        {value: 'portion-7', viewValue: '8'},
        {value: 'portion-8', viewValue: '9'},
        {value: 'portion-9', viewValue: '10'}
      ]
    } else if (this.itemIndex == 2) {
  
      this.items = [
        {value: 'units-1', viewValue: 'ounce'},
        {value: 'units-2', viewValue: 'kilogram'},
        {value: 'units-0', viewValue: 'cup'},
        {value: 'units-7', viewValue: 'whole'},
        {value: 'units-3', viewValue: 'gram'},
        {value: 'units-4', viewValue: 'pound'},
        {value: 'units-4', viewValue: 'slices'}
      ]
    } else if (this.itemIndex == 3) {
      this.items = [
        {value: 'type-0', viewValue: 'N/A'},
        {value: 'type-1', viewValue: 'Sandwich'},
        {value: 'type-2', viewValue: 'Soup'},
        {value: 'type-3', viewValue: 'Pasta'},
        {value: 'type-4', viewValue: 'Veggie Salad'},
        {value: 'type-5', viewValue: 'Protein Salad'},
        {value: 'type-6', viewValue: 'Dessert'},
      ]
    } else if (this.itemIndex == 5) {
      this.items = [
        {value: 'prep-0', viewValue: 'N/A'},
        {value: 'prep-1', viewValue: 'Drink/Liquid'},
        {value: 'prep-2', viewValue: 'Vegetable'},
        {value: 'prep-3', viewValue: 'Fruit'},
        {value: 'prep-4', viewValue: 'Grain/Starch'},
        {value: 'prep-5', viewValue: 'Meat'},
        {value: 'prep-6', viewValue: 'Dairy'},
      ]
    }
    else if (this.itemIndex == 4) {
      this.items = [
        {value: 'activ-0', viewValue: 'Walking'},
        {value: 'activ-1', viewValue: 'Running'},
        {value: 'activ-2', viewValue: 'Biking'},
        {value: 'activ-3', viewValue: 'Swimming'},
        {value: 'activ-4', viewValue: 'Ball Sports'},
        {value: 'activ-5', viewValue: 'Dancing'},
        {value: 'activ-6', viewValue: 'Weight Lifting/Gym'},
        {value: 'activ-7', viewValue: 'Gardening'},
        {value: 'activ-8', viewValue: 'Yoga'},
        {value: 'activ-9', viewValue: 'Pilates'},
        {value: 'activ-9', viewValue: 'Jump Rope'},
      ]
    } else if (this.itemIndex == 7) {
      this.items = [
        {value: 'plan-0', viewValue: 'Cut Down Junk'},
        {value: 'plan-1', viewValue: 'Add Healthy Food'},
      ]
    }
    else if (this.itemIndex == 8) {
      this.items = [
        {value: 'intensity-0', viewValue: 'Light Intensity'},
        {value: 'intensity-1', viewValue: 'Moderate Intensity'},
        {value: 'intensity-2', viewValue: 'Heavy Intensity'},
      ]
    }
    else if (this.itemIndex == 10) {
      this.items = [];
      for (var i in this.itemList) {
        this.items.push(
          {value: 'unit-' + i, viewValue: this.itemList[i]}
        );
      }
    }
  }
}

